<template>
    <div>
        <navBox></navBox>
        <div class="banner" v-if="types == 'show'">
            <img :src="fullpathImg" alt="" />
        </div>
        <div class="banner" v-if="types == 'link'">
            <router-link :to="{ path: pathUrl }">
                <img :src="fullpathImg" alt="" />
            </router-link>
        </div>

        <subNav leadStyle="2px solid #283254"></subNav>
        <div class="leadership">
            <div class="wrap">
                <div class="title">Management</div>
                <div class="content">
                    <template v-for="item, key in leadershipList">
                        <div class="ManagementList">
                            <div class="mgt_vivd">
                                <div class="caption">{{item.name}}</div>
                                <div class="ceo">{{item.job.length>75?item.job.substring(0,75)+"...":item.job}}</div>
                                <div><img :src="item.pic_fullpath" alt=""></div>
                            </div>
                            <div class="mgt_explain" v-html="item.explain"></div>
                            <div class="clear"></div>
                        </div>
                    </template>

                    <!-- <ul>
                        <li v-for="(item,index) in leadershipList" :key="index">
                            <div class="caption">{{item.name}}</div>
                            <div class="ceo">{{item.job.length>25?item.job.substring(0,25)+"...":item.job}}</div>
                            <div><img :src="item.pic_fullpath" alt=""></div>
                        </li>
                    </ul> -->
                </div>
            </div>
        </div>
        <!-- <mapBox></mapBox> -->
        <footerBox></footerBox>
    </div>
</template>
<script>
import footerBox from "@/components/footerBox/footerBox";
import navBox from "@/components/navBox/navBox";
import subNav from "@/components/subNav/subNav";
import mapBox from "@/components/mapBox/mapBox";
export default {
    name: "leadership",
    components: { footerBox, navBox, subNav, mapBox },
    data(){
        return{
            leadershipList:[],
            types: "",
            fullpathImg:"",
            pathUrl:'',
        }
    },
    created(){
         this.$http.getIrCorporate().then(res=>{
            console.log(res)
            this.types =  res.config["Banner-banner-head"][0].types;
            this.fullpathImg=res.config["Banner-banner-head"][0].pic_fullpath;
            this.pathUrl=res.config["Banner-banner-head"][0].links;
            this.leadershipList=res.config["Business-member-management"]
        })
    }
};
</script>
<style lang="less" scoped>
.wrap {
    width: 1200px;
    margin: 0 auto;
}

/*banner*/
.banner img {
    width: 100%;
    // height: 220px;
}
//内容
.leadership {
    padding-bottom: 200px;
    .title {
        font-size: 30px;
        color: #333333;
        font-weight: bold;
        padding: 70px 0 50px 0;
    }
    .content{
        // border: 1px solid #dcdcdc;
        padding: 25px 25px 60px 25px;
        ul{
            border-bottom: 1px solid #e9e9e9;
            display: flex;
            flex-wrap: wrap;
            li{
                padding: 35px;
                width: 215px;
                .caption{
                    font-size: 14px;
                    color: #283254;
                    font-weight: bold;
                    border-bottom: 2px solid #aaacb6;
                    display: inline-block;
                    margin-bottom: 10px;
                    height: 20px;
                    font-family: 'Lucida Bright';
                }
                .ceo{
                    color: #333333;
                    font-size: 14px;
                    margin-bottom: 25px;
                    height: 20px;
                    font-family: 'Lucida Bright';
                }
                img{
                    width: 215px;
                    height: 215px;
                }
            }
        }
        .ManagementList {
            min-height: 320px;
            border-bottom: 1px #CCCCCC solid;
            .mgt_vivd {
                width: 30%;
                padding: 10px 10px 10px 20px;
                float: left;
                .caption{
                    font-size: 14px;
                    color: #283254;
                    font-weight: bold;
                    border-bottom: 2px solid #aaacb6;
                    display: inline-block;
                    margin-bottom: 10px;
                    height: 20px;
                    font-family: 'Lucida Bright';
                }
                .ceo{
                    color: #333333;
                    font-size: 14px;
                    margin-bottom: 25px;
                    height: 20px;
                    font-family: 'Lucida Bright';
                }
                img{
                    width: 215px;
                    height: 215px;
                }
            }
            .mgt_explain{
                float: right;
                width: 60%;
                height: 100%;
                padding: 85px 0px 30px 10px;
                line-height: 24px;
                font-family: "Lucida Bright";
                // text-align-last:justify;
            }
        }
    }
}
.clear {
    clear: both;
}
</style>